import { render } from "./Toolbar.vue?vue&type=template&id=ba50455c&bindings={}"
import script from "./Toolbar.vue?vue&type=script&lang=ts"
export * from "./Toolbar.vue?vue&type=script&lang=ts"
script.render = render

export default script